<div class="scroll-to-top" [ngClass]="{'show-scrollTop': windowScrolled}">
    <button class="scroll-top-btn" type="button" data-toggle="button" aria-pressed="true" aria-label="Scroll to Top" (click)="scrollToTop()">
        <fa-icon class="scroll-top-icon fa-2xl" [icon]="faChevronUp"></fa-icon>
    </button>
</div>